<template>
  <div>
        <div class="block-content">
        

        <form class="form-horizontal" action="base_forms_premade.html" method="post" onsubmit="return false;">
            <h3 class="font-w300 push-10">{{ sectionLabelCreateOrganisation[actualLanguage] }}</h3>
          
            <div class="form-group">
                <div class="col-xs-12">
                    <label for="register4-firstname">{{ labelTextBoxOrganisation[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="organizationModel.organizationInfo.name" placeholder="Organisation / Organization...">
                </div>
            </div>

            <div class="form-group">
                <div class="col-xs-12">
                    <label for="register4-firstname">{{ labelTextBoxAdress[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="organizationModel.organizationInfo.address" placeholder="Adresse / Address...">
                </div>
            </div>

            <div class="form-group">
                <div class="col-xs-4">
                    <label for="register4-firstname">{{ labelTextBoxCity[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="organizationModel.organizationInfo.city" placeholder="Ville / City...">
                </div>

                <div class="col-xs-4">
                    <label for="register4-firstname">{{ labelTextBoxProvince[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="organizationModel.organizationInfo.province" placeholder="Province / State ...">
                </div>

                <div class="col-xs-4">
                    <label for="register4-firstname">{{ labelTextBoxCountry[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="organizationModel.organizationInfo.country" placeholder="Pays / Country ...">
                </div>            
            </div>

            <div class="form-group">
                <div class="col-xs-4">
                    <label for="register4-firstname">{{ labelTextBoxPostalCode[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="organizationModel.organizationInfo.postalCode" placeholder="Code postal / Postal code...">
                </div>

                <div class="col-xs-8">
                    <label for="register4-firstname">{{ labelTextBoxPhone[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="organizationModel.organizationInfo.phoneNumber" placeholder="555-555-5555">
                </div>            
            </div>



            
            <h3 class="font-w300 push-10">{{ labelSectionContactPerson[actualLanguage] }}</h3>
            

            <div class="form-group">
                <div class="col-xs-6">
                    <label for="register4-firstname">{{ labelSectionContactPersonFirstname[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="organizationModel.managers[0].firstName" placeholder="Prénom/first name..">
                </div>

                <div class="col-xs-6">
                    <label for="register4-lastname">{{ labelSectionContactPersonLastname[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="organizationModel.managers[0].lastName" placeholder="Nom/last name..">
                </div>

                <div class="col-xs-6">
                    <label for="register4-firstname">{{ labelSectionContactPersonEmail[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="organizationModel.managers[0].email" placeholder="Courriel/email">
                </div>

                <div class="col-xs-6">
                    <label for="register4-lastname">{{ labelSectionContactPersonPhone[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="organizationModel.managers[0].phoneNumber" placeholder="555-555-5555">
                </div>
            </div>

            <div class="form-group">
              <div class="col-sm-12 col-md-12">
                <div>
                    <p><button @click="saveOrganization()" type="button" class="btn btn-block btn-success" name="button">
                      <spinner size="small" v-if="organizationIsSaving"></spinner>
                      <span v-else><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-industry fa-1x push-5-r "></i>{{ buttonLabelSave[actualLanguage] }}</span></button></p>
                </div> 
              </div>
            </div>
          

          </form>
        </div>




  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'AddOrganizationForm',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      organizationIsSaving: false,
      organizationModel: {
        organizationInfo : {name:'',
                            address:'',
                            city:'',
                            province:'',
                            country:'',
                            postalCode:'',
                            phoneNumber:''},
        managers: [{profileId:'TBD',
                            firstName:'TBD',
                            lastName:'TBD',
                            email:'TBD',
                            phoneNumber:'',
                            mainContactFlag:false}]           

      },

      actualLanguage : "FR",
      labelFieldEvName: {FR: 'Nom du Véhicule/Borne', EN: 'Vehicle/Charger Name'},

      sectionLabelCreateOrganisation:{FR: "Créer une organisation", EN: 'Create an organization'},
      labelTextBoxOrganisation:{FR: "Nom de l'organisation", EN: 'Organization name'},
      labelTextBoxAdress:{FR: "Adresse", EN: 'Address'},
      labelTextBoxCity:{FR: "Ville", EN: 'City'},
      labelTextBoxProvince:{FR: "Province", EN: 'Province'},
      labelTextBoxCountry:{FR: "Pays", EN: 'Country'},
      labelTextBoxPostalCode:{FR: "Code Postal", EN: 'Postal code'},
      labelTextBoxPhone:{FR: "Numéro téléphone", EN: 'Phone number'},

      labelSectionContactPerson:{FR: "Personne contact", EN: 'Contact person'},
      labelSectionContactPersonFirstname:{FR: "Prénom", EN: 'First name'},
      labelSectionContactPersonLastname:{FR: "Nom", EN: 'Last name'},
      labelSectionContactPersonEmail:{FR: "Courriel", EN: 'Email'},
      labelSectionContactPersonPhone:{FR: "Téléphone", EN: 'Phone number'},

      buttonLabelSave:{FR: "Enregistrer", EN: 'Save'},
      messageAllFiledRequired:{FR: "Vous devez remplir tous les champs.", EN: 'You must fill all fields.'},
      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},

    }
  },
  methods: {

    saveOrganization() {
      var DataCheck = true
      DataCheck = DataCheck && (this.organizationModel.organizationInfo.name.length > 0)
      DataCheck = DataCheck && (this.organizationModel.organizationInfo.address.length > 0)
      DataCheck = DataCheck && (this.organizationModel.organizationInfo.city.length > 0)
      DataCheck = DataCheck && (this.organizationModel.organizationInfo.province.length > 0)
      DataCheck = DataCheck && (this.organizationModel.organizationInfo.country.length > 0)
      DataCheck = DataCheck && (this.organizationModel.organizationInfo.postalCode.length > 0)
      DataCheck = DataCheck && (this.organizationModel.organizationInfo.phoneNumber.length > 0)
      DataCheck = DataCheck && (this.organizationModel.managers[0].phoneNumber.length > 0)

      if(DataCheck == false){
        window.alert(this.messageAllFiledRequired[this.actualLanguage])
      }else{
        this.organizationIsSaving = true
        var requestData = { 'postAction':'AddOrganizationToProfile',
                          'organizationData': this.organizationModel
                          }
        this.$store.dispatch('sessionStore/postProfile', requestData)
            .then((response) => {
              //console.log(response.data)
              this.organizationIsSaving = false
            if(response.data.Code=='OK'){
                this.$store.dispatch('sessionStore/refreshProfileData')
                this.$store.dispatch('overlayStore/toggleModal',false)
                }
                else{ window.alert(this.messagePostFail[this.actualLanguage])}
            })       
      }

    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData']),
  },

  mounted() {
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    //console.log('-----Profile Data----')
    //console.log(this.profileData)
    this.organizationModel.managers[0].profileId = this.profileData.profileId
    this.organizationModel.managers[0].firstName = this.profileData.profileInfo.firstName
    this.organizationModel.managers[0].lastName = this.profileData.profileInfo.lastName
    this.organizationModel.managers[0].email = this.profileData.profileInfo.email
    this.organizationModel.managers[0].mainContactFlag = true


  }


}
</script>



// WEBPACK FOOTER //
// OrganizationAddForm.vue?2473c7d7